<template>
	<vs-prompt
		@cancel=""
		@accept="changeOrderStatus"
		:active.sync="popupActive"
		:title="$t('titleDialogChangeOrderStatus')"
		:acceptText="$t('save')"
		:cancelText="$t('cancel')"
		class="add-order-task"
	>
		<div>
			<vx-input-group class="mb-4">
                <div class="form-group form-check">
                    <div class="mb-4"><input class="mr-2" id="new_status_clientNotAnswer" type="radio" v-model="new_status" value="clientNotAnswer"> <label for="new_status_clientNotAnswer">{{ $t('clientNotAnswer') }}</label></div>
                    <div class="mb-4"><input class="mr-2" id="new_status_processing" type="radio" v-model="new_status" value="processing"> <label for="new_status_processing">{{ $t('processing') }}</label></div>
                    <div class="mb-4"><input class="mr-2" id="new_status_waitingPayment" type="radio" v-model="new_status" value="waitingPayment"> <label for="new_status_waitingPayment">{{ $t('waitingPayment') }}</label></div>
                    <div class="mb-4"><input class="mr-2" id="new_status_waitingAuthor" type="radio" v-model="new_status" value="waitingAuthor"> <label for="new_status_waitingAuthor">{{ $t('waitingAuthor') }}</label></div>
                    <div class="mb-4"><input class="mr-2" id="new_status_inProgress" type="radio" v-model="new_status" value="inProgress"> <label for="new_status_inProgress">{{ $t('inProgress') }}</label></div>
                    <div class="mb-4"><input class="mr-2" id="new_status_waitingApprove" type="radio" v-model="new_status" value="waitingApprove"> <label for="new_status_waitingApprove">{{ $t('waitingApprove') }}</label></div>
                </div>
			</vx-input-group>
		</div>
	</vs-prompt>
</template>

<script>
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";

    export default {
        name: "ChangeOrderStatus",
        mixins: [databaseManager, notifier],
        props: {
            active: { required: true, type: Boolean },
            order: { required: true },
        },
        data() {
            return {
                new_status: "0",
            }
        },
        watch: {
            popupActive(value) {
                if(value) return;
            }
        },
        computed: {
            popupActive: {
                get() {
                    return this.active;
                },
                set(newValue) {
                    this.$emit("update:active", newValue);
                }
            },
        },
        methods: {
            async changeOrderStatus() {
                this.popupActive = true;

                try {
                    let rez = false;
                    rez = await this.dbChangeOrderStatus(this.order.id, this.new_status);
                    if(rez) {
                        this.popupActive = false;
                        this.notifySuccess(this.$t('changesIsSavedSuccessfully'));
                        this.$emit("updateModel");
                    }
                } catch (e) {
                    this.notifyError(e.message)
                }
            },
        }
    };
</script>

<style lang="scss">
.add-order-task {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}
</style>
